export default {
  path: '/name-success',
  meta: {
    title: '认证成功',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/name-success`),
}



// WEBPACK FOOTER //
// ./src/views/NameSuccess/router.js